export const servicesColumns = [
  { field: "id", label: "ID" },
  { field: "name", label: "Name" },
  { field: "action", label: "Action" },

];

export const data = [
  {
    title: "Wash & Fold",
    label: "wash_fold",
    rows: [
      { id: 1, name: "Household" },
      { id: 2, name: "Dailywear" },
      { id: 3, name: "Partywear" },
    ],
  },
  {
    title: "Tailoring,Ironing,Dry Cleaning",
    label: "cloth_category",
    rows: [
      { id: 1, name: "Cotton" },
      { id: 2, name: "Wool" },
    ],
  },
  {
    title: "Cloth Name",
    label: "cloth_name",
    rows: [
      { id: 1, name: "Shirt"},
      { id: 2, name: "Kurta" },
      { id: 4, name: "Saree" },
    ],
  },
  {
    title: "Tailoring Type",
    label: "tailoring_type",

    rows: [
      { id: 1, name: "Simple Stitch" },
      { id: 2, name: "Designer Stitch"},
    ],
  },
];